import HTTP from "@/_helpers/http";
import { RMSSETTINGS__API } from "@/_helpers/urls";
import { RMSSETTINGS__MUTATIONS } from "../mutation-types";
import { RMSSETTINGS__ACTIONS } from "../action-types";
import toast from "@/services/Notification";


// State
const state = {
  rmssettings: [],
  rmsgraphs: [],
  profitReaches: [],
  autoCreditBack: [],

  creditSummaries: {
    totalRecords: 0,
    totalCredit: 0
  },

  pagination: {
    total: 0,
    perPage: 10,
    currentPage: 1,
    lastPage: 1,
  },
};

//Getters
const getters = {};

//Mutations
const mutations = {
  [RMSSETTINGS__MUTATIONS.RMSSETTINGS](state, data) {
    state.rmssettings = data;
  },
  [RMSSETTINGS__MUTATIONS.RMSGRAPH](state, data) {
    state.rmsgraphs = data;
  },
  [RMSSETTINGS__MUTATIONS.PROFITREACHES](state, data) {    
    state.profitReaches = data?.data?.rows    
    state.pagination = data?.data?.pagination
    state.summaries = data?.data?.summaries
  },
  [RMSSETTINGS__MUTATIONS.AUTOCREDITBACK](state, data) {    
    state.autoCreditBack = data?.data?.rows    
    state.pagination = data?.data?.pagination
    state.creditSummaries = data?.data?.creditSummaries
  }
};

// Actions
const actions = {
  async [RMSSETTINGS__ACTIONS.RMSSETTINGS]({ commit, state }, id) {
    try {
      const url = `${RMSSETTINGS__API.RMSSETTINGS}`;
      const response = await HTTP().get(url);

      if (response.status === 200) {
        commit(RMSSETTINGS__MUTATIONS.RMSSETTINGS, response.data?.data);
      } else {
        commit(RMSSETTINGS__MUTATIONS.RMSSETTINGS, []);
      }
    } catch (error) {
      console.log(error);
    }
  },
  async [RMSSETTINGS__ACTIONS.RMSGRAPH]({ commit, state }, id) {
    try {
      const url = `${RMSSETTINGS__API.RMSGRAPH}`;
      const response = await HTTP().get(url);

      if (response.status === 200) {
        commit(RMSSETTINGS__MUTATIONS.RMSGRAPH, response.data?.data);
      } else {
        commit(RMSSETTINGS__MUTATIONS.RMSGRAPH, []);
      }
    } catch (error) {
      console.log(error);
    }
  },
  async [RMSSETTINGS__ACTIONS.PROFITREACHES]({ commit, state }, parameter={}) {
    try {
      const {
        page = 1,
        limit = 10,
        search = "",
        book,
      } = parameter || {};

      const queryParams = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        ...(book && { book }),
        ...(search && { search }),
      }).toString();

      const response = await HTTP().get(
        `${RMSSETTINGS__API.PROFITREACHES}${queryParams ? `?${queryParams}` : ""}`
      );

      if (response.status === 200) {
        commit(RMSSETTINGS__MUTATIONS.PROFITREACHES, response.data);
      }
    } catch (error) {
      console.log(error);
    }
  },
  async [RMSSETTINGS__ACTIONS.AUTOCREDITBACK]({ commit, state }, parameter={}) {
    try {
      const {
        page = 1,
        limit = 10,
        search = "",
      } = parameter || {};

      const queryParams = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        ...(search && { search }),
      }).toString();

      const response = await HTTP().get(
        `${RMSSETTINGS__API.AUTOCREDITBACK}${queryParams ? `?${queryParams}` : ""}`
      );

      if (response.status === 200) {
        commit(RMSSETTINGS__MUTATIONS.AUTOCREDITBACK, response.data);
      }
    } catch (error) {
      console.log(error);
    }
  },

  async [RMSSETTINGS__ACTIONS.UPDATEPROFITREACHES](
    { commit, state, dispatch },
    parameter
  ) {

    try {
      const res = await HTTP().patch(RMSSETTINGS__API.UPDATEPROFITREACHES, parameter);
      await dispatch(RMSSETTINGS__MUTATIONS.PROFITREACHES);

      if (res.status === 200) {
        toast.success("Client Switched to A Book Successfully");
      }

    } catch (error) {
      console.log(error);
      toast.error("Client Switching to A Book Failed");
    }
  },

  async [RMSSETTINGS__ACTIONS.UPDATERMSSETTINGS](
    { commit, state, dispatch },
    parameter
  ) {
    try {
      await HTTP().patch(RMSSETTINGS__API.UPDATERMSSETTINGS, parameter);
      await dispatch(RMSSETTINGS__MUTATIONS.RMSSETTINGS);
    } catch (error) {
      console.log(error);
    }
  },
};

export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== "production",
  state,
  getters,
  mutations,
  actions,
};
